export default {
  color: {
    theme: "#0f142b",
    black: "#333",
    yellow: "#facc00",
    yellowDarker: "#bd9a00",
    white: "#fff",
    blue: "#005bbb",
    blueDarker: "#023f80",
    red: "#bb0000",
    redDarker: "#820202",
    gray: "#585858",
    grayLighter: "#808080",
    silver: "#eaeaea",
  },
  borderRadius: {
    small: "2px",
    large: "20px",
  },
  breakPointers: {
    small: "768px",
    medium: "992px",
    large: "1024px",
  },
};
